import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const verifyBox = (invoice, box) => apiActionCreator({
  'endpoint': `/checkProcesses/invoices/${invoice}/boxes/${box}/verification`,
  'authenticated': true,
  'types': [
    ActionTypes.VERIFYING_BOX,
    ActionTypes.VERIFIED_BOX,
    [
      ActionTypes.VERIFIED_BOX_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
